<div mat-dialog-content class="pb-16">
    <div class="text-bold font-size-20 artstuff-orange-fg mb-60">
        {{'APP_SWITCHER_DIALOG.SWITCH_MODULE' | translate }}
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="px-104 mb-60">
        <app-switcher (navigationApp)="closeDialog($event)" [size]="'s-size'"></app-switcher>
    </div>
</div>
<div mat-dialog-actions>
    <div fxLayout="row" fxLayoutAlign="end end">
        <button mat-flat-button (click)="closeDialog($event)" class="secondary-text artstuff-dialog-button">
            {{'APP_SWITCHER_DIALOG.CLOSE' | translate }}</button>
    </div>
  </div>